var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.119,
    height: 27.124,
    viewBox: "0 0 27.119 27.124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-chatboxes",
    "data-name": "Icon ionic-ios-chatboxes",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_782",
    "data-name": "Caminho 782",
    d: "M28.62,11.981H14.17a2.488,2.488,0,0,0-2.484,2.484V24.527A2.482,2.482,0,0,0,14.17,27h8.268a.713.713,0,0,1,.5.209L27.042,31c.228.222.606.13.606-.189v-3.3c0-.391.248-.515.639-.515h.065A2.714,2.714,0,0,0,31.1,24.52V14.466A2.474,2.474,0,0,0,28.62,11.981Z",
    transform: "translate(-0.604 -0.625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_783",
    "data-name": "Caminho 783",
    d: "M11.617,9.759H23.185V5.5a2.126,2.126,0,0,0-2.126-2.126H5.5A2.126,2.126,0,0,0,3.375,5.5V16.273A2.126,2.126,0,0,0,5.5,18.4H9.485V11.884A2.136,2.136,0,0,1,11.617,9.759Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/icon-chat.ee9c27a61f199245ef44ac7c6d67a172.svg";
export { ForwardRef as ReactComponent };